// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__30hdo","title":"Info_title__2aR7L","links":"Info_links__3C3is","link":"Info_link__30YWB","logo":"Info_logo__ZNn8L"};